/**
 * De webstap van /export/v2: een pagina op de backend rondt de export af in
 * een eigen venster. Na afloop stuurt die pagina door naar EXPORT_RETURN_PATH
 * van de webportal; die meldt de afloop via een BroadcastChannel aan het
 * tabblad met de wizard. De callback draagt geen gegevens: de wizard vraagt
 * daarna zelf de stand op.
 */

export const EXPORT_RETURN_PATH = '/export/klaar';

const CHANNEL_NAME = 'notizy.export-v2';

export const exportReturnUrl = (): string => `${window.location.origin}${EXPORT_RETURN_PATH}`;

/**
 * Opent in de klik zelf een leeg venster, zodat de popupblokker het toelaat;
 * de url volgt pas als de webstap is aangevraagd. null = tegengehouden.
 */
export const openPendingWindow = (title: string, text: string): Window | null => {
    let win: Window | null = null;
    try {
        win = window.open('', '_blank');
    } catch {
        return null;
    }
    if (!win) return null;
    try {
        win.document.title = title;
        win.document.body.textContent = text;
        win.document.body.style.font = '14px system-ui, sans-serif';
        win.document.body.style.padding = '24px';
    } catch {
        // Een leeg venster zonder tekst is ook goed
    }
    return win;
};

/** Stuurt het lege venster naar de webstap; de backendpagina krijgt geen toegang tot dit tabblad. */
export const navigatePendingWindow = (win: Window, url: string): void => {
    try {
        win.opener = null;
    } catch {
        // Niet te wissen; de pagina op de backend gebruikt opener niet
    }
    win.location.href = url;
};

export const closePendingWindow = (win: Window | null): void => {
    try {
        if (win && !win.closed) win.close();
    } catch {
        // Al dicht
    }
};

export interface WebSessionReturn {
    sessionId: string;
    status: string;
}

export const announceWebSessionReturn = (message: WebSessionReturn): void => {
    if (typeof BroadcastChannel === 'undefined') return;
    try {
        const channel = new BroadcastChannel(CHANNEL_NAME);
        channel.postMessage(message);
        channel.close();
    } catch {
        // Dan merkt de wizard het bij het volgende opvragen van de stand
    }
};

/** Luistert naar de terugkeerpagina; geeft een functie om te stoppen. */
export const listenForWebSessionReturn = (onReturn: (message: WebSessionReturn) => void): (() => void) => {
    if (typeof BroadcastChannel === 'undefined') return () => {};
    let channel: BroadcastChannel;
    try {
        channel = new BroadcastChannel(CHANNEL_NAME);
    } catch {
        return () => {};
    }
    channel.onmessage = (event: MessageEvent) => {
        const data = event.data;
        if (data && typeof data.sessionId === 'string' && typeof data.status === 'string') {
            onReturn({ sessionId: data.sessionId, status: data.status });
        }
    };
    return () => channel.close();
};
